import { Footer } from "../container";
//import FooterBook from "../container/FooterBook/FooterBook";
import HeaderBook from "../container/LibroAzul/HeaderBook/HeaderBook";
import NavbarBook from "../container/LibroAzul/NavBarBook/NavBarBook";
import Home_cinco from "../container/Home/home_cinco/libro_azul_more/Libro_azul_more";
import Navbar from '../container/navbar/Navbar'
import {NLV_Coleccion} from '../container';



import styles from '../container/LibroAzul/BookBlue.module.scss'

import { PopupProvider } from "../context/PopupProvider";
import { useContext } from "react";
import { PopupContext } from "../context/PopupContext";
import { PopupContainer } from "../container/LibroAzul/PopupContainer/PopupContainer";


const LibroAzul = () => {

    return (
        <PopupProvider>
            <div className={`${styles.Background} ${styles.Background_BookBlue}`}>
                <PopupContainer />
                <Navbar link='https://www.elektra.mx/ideas-que-transforman-negocios-para-cambiar-al-mundo-100001071/p'/>
                <HeaderBook />
                <NLV_Coleccion/>
                <Home_cinco/>
                <Footer />
            </div>
        </PopupProvider>
    );

}

export default LibroAzul;